<template>
  <layout-default-dialog-appbar :back-to="apontamentoEmbarque" withDialog>
    Cadastro Apontamento Embarque
  </layout-default-dialog-appbar>
</template>

<script>
import LayoutDefaultDialogAppbar from '@/layouts/default/DialogAppBar.vue';

import { ROUTE_APONTAMENTO_EMBARQUE } from '@/constants/ROUTES';
import { ROTA_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultDialogAppbar,
  },

  data() {
    return {
      apontamentoEmbarque: ROUTE_APONTAMENTO_EMBARQUE,
    };
  },

  created() {
    sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoCadastro');
  },
};
</script>
